import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import Logo from '../assets/COOPER_NEW.png';
import LogoRMS from '../assets/rms_logo.png';
import LogoRMSWhite from '../assets/rms_white.png';
import ButtonImg from '../assets/button.svg';
import ButtonWhiteImg from '../assets/button_white.svg';
import '../scss/auth.scss';
import { getThemeMode, ThemeMode } from '../utils/theme';
import { appConfig } from '../utils/appConfig';

function Authentication() {
    const navigate = useNavigate();
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [themeMode, setThemeModeState] = useState<ThemeMode>(() => {
        return getThemeMode();
      });   
    // Redirect if already authenticated
    useEffect(() => {
        sessionStorage.removeItem('tokenExpiry');
        sessionStorage.removeItem('accessToken');
    }, []);

    useEffect(() => {
        const sessionExpired = localStorage.getItem('session_expired') === 'true';
        const expiry = sessionStorage.getItem('tokenExpiry');
        const tokenValid = expiry ? new Date(expiry) > new Date() : false;
        const hasActiveAccount = !!instance.getActiveAccount();
        if (isAuthenticated && !sessionExpired && tokenValid && hasActiveAccount) {
            navigate('/chat');
        }
        localStorage.removeItem('session_expired');
    }, [isAuthenticated, navigate, instance]);

    // Determine environment label based on URL
    const environmentLabel = useMemo(() => {
        const windowUrl = window.location.href;
        if (windowUrl.includes('localhost') || windowUrl.includes('-dev')) {
            return 'DEVELOPMENT';
        }
        if (windowUrl.includes('-test')) {
            return 'TESTING';
        }
        return null;
    }, []);

    const handleLogin = () => {
        instance.loginPopup(loginRequest)
            .then((result) => {
                instance.setActiveAccount(result.account);
                navigate('/chat');
            })
            .catch((error) => {
                console.error('Login failed:', error);
            });
    };

    return (
        <div className="authentication-wrapper">
            <div className='main-section'>
                {appConfig.projectName === 'AskCooper AI' && (
                    <img src={Logo} className='logo' alt="Cooper Logo" />
                )}
                {environmentLabel && (
                    <h2 className='env'>{environmentLabel}</h2>
                )}
                {appConfig.projectName === 'AskCooper AI' ? (
                    <h1 className='label'>AskCooper AI</h1>
                ) : (
                    <img src={themeMode === 'dark' ? LogoRMSWhite : LogoRMS} className='logo2' alt="Turbo AI Logo" />
                )}
                <img 
                    src={appConfig.projectName === 'AskCooper AI' && themeMode === 'dark' ? ButtonImg : ButtonWhiteImg}
                    className='btn' 
                    onClick={handleLogin}
                    alt="Login Button"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleLogin();
                        }
                    }}
                />
            </div>
            {appConfig.projectName === 'AskCooper AI' ? (
                <>
                <div className='bg' />
                <div className='bg-img' />
                </>
            ) : (
                <div className='bg-img2' />
            )}
            <p className='version'>v. {appConfig.version}</p>
        </div>
    );
}

export default Authentication;
